<template id="client-view">
  <v-card class="" flat>
    <div loader-height="2" :loading="loading" :disabled="loading">
      <div>
            <v-card-text class=" d-flex align-center">
              <AppBreadcrumbs :items="breadcrumbs" />
              <v-spacer></v-spacer>
              <v-text-field
                label="Search"
                outlined
                hide-details
                dense
                v-model="search"
                class="mr-2"
              ></v-text-field>
              <v-btn  elevation="0" class="mr-2 primaryBtn" @click="addflag = true; edit = false; modifydata = {}; showDialog = true;">
                <p>Add New Entity</p>
              </v-btn>
              <v-btn icon @click="refreshData()" class="primaryBtn">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </v-card-text>
        <lb-datatablenew
          :headers="datatableHeaders"
          :items="filteredFormatedData"
          item-key="_id"
          class="elevation-0 cursor-pointer main-card pt-0"
          :loading="loading"
          :enableslot="['type', 'aiEnabled', 'schedulerEnabled', 'userPermission', 'pinCount', 'chatbotEnabled']"
          :perpage="Infinity"
        >
          <template #type="{ item }">
            <v-chip class=""><span>{{ item.type }}</span></v-chip>
          </template>
          <template #aiEnabled="{ item }">
            <v-icon :color="item.aiEnabled ? 'success' : 'error'">
              {{ item.aiEnabled ? 'mdi-check-circle' : 'mdi-close-circle' }}
            </v-icon>
          </template>
          <template #schedulerEnabled="{ item }">
            <v-icon :color="item.schedulerEnabled ? 'success' : 'error'">
              {{ item.schedulerEnabled ? 'mdi-check-circle' : 'mdi-close-circle' }}
            </v-icon>
          </template>
          <template #userPermission="{ item }">
            <v-icon :color="item.userPermission ? 'success' : 'error'">
              {{ item.userPermission ? 'mdi-check-circle' : 'mdi-close-circle' }}
            </v-icon>
          </template>
          <template #pinCount="{ item }">
            <v-icon :color="item.pinCount !== -1 ? 'success' : 'error'">
              {{ item.pinCount !== -1 ? 'mdi-check-circle' : 'mdi-close-circle' }}
            </v-icon>
          </template>
          <template #chatbotEnabled="{ item }">
            <v-icon :color="item.chatbotEnabled ? 'success' : 'error'">
              {{ item.chatbotEnabled ? 'mdi-check-circle' : 'mdi-close-circle' }}
            </v-icon>
          </template>
          <template #no-data>
            <v-alert type="info" text border="left">
              Add new Entity
            </v-alert>
          </template>
        </lb-datatablenew>
      </div>
    </div>

    <v-dialog v-model="showDialog" max-width="1000">
      <v-card>
        <v-card-text class="pa-4">
          <div class="pb-4 d-flex title align-center">
            <span v-if="addflag" class="">Add New Entity</span>
            <span v-else-if="editflag" class="">Edit Entity Details</span>
            <v-spacer></v-spacer>
          </div>
          <EntityForm
            :addflag="addflag"
            :editflag="editflag"
            :modifydata.sync="modifydata"
            :errors="errors"
            :selectdata="selectdata"
            :industries="industries"
            :sectors="sectors"
            :size="size"
            :plans="plans"
            :allUsers="allUsers"
            :isEnabled.sync="isEnabled"
            @sod-switch="handleSwitchChange"
            @cancel="() => { addflag = false; editflag = false; showDialog = false; modifydata = (listdata.length >= selectedindex + 1 && listdata.length > 0) ? listdata[selectedindex] : {}; }"
            @save="save"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
// @ is an alias to /src
// import pageHeader from '@/components/pageHeader'
// import managelist from '@/components/ManageList'

import EntityForm from './components/EntityForm.vue';
import AppBreadcrumbs from '@/views/common/AppBreadcrumbs.vue';

export default {
  name: "clientv2",
  components: {
    EntityForm,
    AppBreadcrumbs
  },
  data: function () {
    return {
      listdata: [],
      formatedData: [],
      datatableHeaders: this.$store.state.datatableHeaders,
      plans: this.$store.state.plans || [],
      loading: false,
      addflag: false,
      editflag: false,
      selectedindex: 0,
      modifydata: {},
      errors: {},
      search: '',
      selectdata: this.$store.state.selectdata,
      allUsers: [],
      industries: this.$store.state.industries || [],
      sectors: this.$store.state.sectors || {},
      size: this.$store.state.size || [],
      isEnabled:false,
      showDialog: false
    };
  },
  created() {
    this.refreshData();
  },
  activated() {
    this.refreshData();
  },
  methods: {
    onRowClick(item) {
      this.modifydata = { ...item };
      this.selectedindex = this.filteredList.findIndex((v) => v._id === item._id);
      this.editflag = false;
      this.add = false;
      this.$nova.gotoLink({ path: '/admin/client/id/' + item._id });
    },
    refreshData() {
      this.errors = {};
      this.addflag = false;
      this.editflag = false;
      this.getData();
    },
    getData() {
      this.loading = true;
      this.axios
        .post("/v2/client/get")
        .then((dt) => {
          if (dt.data.status === "success") {
            this.listdata = dt.data.data;
            if (Object.keys(this.modifydata).length === 0)
              this.modifydata = {
                ...(this.listdata.length > 0 ? this.listdata[0] : {}),
              };

            this.axios
              .post("/v2/client/getallusers")
              .then((dt) => {
                if (dt.data.status === "success") {
                  this.allUsers = dt.data.data
                }
              })
              .catch((err) => { this.$store.commit("sbError",err.message || err || "Unknown error!");
                console.log(err);
              })
              .finally(() => {
                this.loading = false;
              });
          } else {
            console.log("Error fetching data");
          }
        })
        .catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    validateEntityForm() {
      // Required fields for validation
      const requiredFields = [
        { key: 'name', label: 'Name' },
        { key: 'type', label: 'Type' },
        { key: 'contactperson', label: 'Contact Person' },
        { key: 'contactemail', label: 'Email' },
        { key: 'contactno', label: 'Contact No.' },
        { key: 'industry', label: 'Industry' },
        { key: 'sector', label: 'Sector' },
        { key: 'size', label: 'Size' },
        { key: 'address', label: 'Address' },
        { key: 'plan', label: 'Plan' },
        { key: 'accountmanager', label: 'Account Manager' }
      ];
      let valid = true;
      this.errors = {};
      requiredFields.forEach(field => {
        if (!this.modifydata[field.key] || (Array.isArray(this.modifydata[field.key]) && this.modifydata[field.key].length === 0)) {
          this.errors[field.key] = `${field.label} is required`;
          valid = false;
        }
      });
      return valid;
    },
    save() {
      if (!this.validateEntityForm()) {
        return;
      }
      this.loading = true;
      this.axios
        .post("/v2/client/add", { data: [this.modifydata] })
        .then((dt) => {
          if (dt.data.status === "success") {
            this.$store.commit("sbSuccess", "Client Added");
            this.$nova.gotoLink({
              path: "/admin/client/id/" + (dt.data.data[0] || {})._id,
            });
            this.refreshData();
            this.$store.commit("refreshClient", true);
            this.showDialog = false;
          } else {
            this.errors = {};
            if (dt.data.data.length > 0) {
              if (dt.data.data[0].index0) this.errors = dt.data.data[0].index0;
            }
            throw dt.data.message || "Error adding client";
          }
        })
        .catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSwitchChange() {
      let payload = {"sod": this.isEnabled,
        "client_id": this.modifydata._id
      }
      this.axios.post("/v2/client/switchSod", {data: payload}).then((dt) => {
          if (dt.data.status === "success") {
              this.refreshData()
            }
          }
        )
    }
  },
  computed: {
    breadcrumbs() {
      // Fully dynamic: use route meta.title if available, else fallback to path or Home
      return this.$route.matched.map((r) => {
        let text = r.meta && r.meta.title ? r.meta.title : (r.path.replace(/^\//, '') || 'Home');
        text = text.charAt(0).toUpperCase() + text.slice(1);
        return {
          text,
          disabled: true
        };
      });
    },
    filteredList() {
      if (!this.search) return this.listdata;
      const s = this.search.toLowerCase();
      return this.listdata.filter(
        v =>
          (v.name && v.name.toLowerCase().includes(s)) ||
          (v.contactemail && v.contactemail.toLowerCase().includes(s)) ||
          (v.type && v.type.toLowerCase().includes(s))
      );
    },
    filteredFormatedData() {
      return this.filteredList.map((item, index) => ({
        __key: index,
        __formatedkey: index,
        _id: item._id,
        indexno: index + 1,
        name: item.name,
        contactemail: item.contactemail,
        type: item.type,
        parent: "Primary",
        contactno: item.contactno,
        address: item.address,
        aiEnabled: item.aiEnabled,
        schedulerEnabled: item.schedulerEnabled,
        userPermission: item.user_permissions_superadmin,
        pinCount: item.pinCount != null ? item.pinCount : -1,
        chatbotEnabled: item.chatbotEnabled,
        __click: () => this.onRowClick(item),
      }));
    }
  },
  watch: {},
};
</script>